export default {
  /* 分页查询项目 */
  queryOtaProjectPageapi: '/adminApi/adminapi/project/queryOtaProjectPage',
  /* 新增项目 */
  addOtaProjectapi: '/adminApi/adminapi/project/addOtaProject',
  /* 查询所有项目 */
  queryUpdateApksAllapi: '/adminApi/adminapi/project/queryUpdateApksAll',
  /* 新增OTA */
  saveOtaUpdateapi: '/adminApi/adminapi/otaManger/saveOtaUpdate',
  /* 根据id查询 */
  selectOtaUpdateByIdApi: '/adminApi/adminapi/otaManger/selectOtaUpdateById',
  /* OTA列表 */
  queryOtaUpdatesPageapi: '/adminApi/adminapi/otaManger/queryOtaUpdatesPage',
  /* 编辑OTA */
  updateOTAapi: '/adminApi/adminapi/otaManger/updateOTA',
  /* APP列表 */
  queryAppUpdatesPageapi: '/adminApi/adminapi/app/queryAppUpdatesPage',
  /* 新增app升级 */
  saveAppUpdateapi: '/adminApi/adminapi/app/saveAppUpdate',
  /* 编辑app升级 */
  editAppUpdateapi: '/adminApi/adminapi/app/editAppUpdate',
  /* 清除app升级 */
  delAppUpdateapi: '/adminApi/adminapi/app/delAppUpdate',
  /* 根据id查询 */
  selectAppUpdateByIdApi: '/adminApi/adminapi/app/selectAppUpdateById',

  /* 分页查询设备指令记录 */
  queryDeviceInstructionsPageapi: '/adminApi/adminapi/deviceInstructions/queryDeviceInstructionsPage',
  /* 下发设备指令 */
  addDeviceInstructionsapi: '/adminApi/adminapi/deviceInstructions/addDeviceInstructions',
  /* 获取所有指令 */
  queryDeviceImeiCodeapi: '/adminApi/adminapi/deviceInstructions/queryDeviceImeiCode',
  // 新增设备通道指令 2012-12-2
  insertDeviceCodeapi: '/adminApi/adminapi/deviceInstructions/insertDeviceCode',
  /* 设备日志查询 */
  queryImeiErrorLogPageapi: '/adminApi/adminapi/deviceInstructions/queryImeiErrorLogPage',
  /* OTA升级记录 */
  queryDownloadLogsPageapi: '/adminApi/adminapi/otaManger/queryDownloadLogsPage',
  /* APP黑名单 */
  queryDeviceAppExcludePageapi: '/adminApi/adminapi/appExclude/queryDeviceAppExcludePage',
  /* 新增APP黑名单 */
  insertDeviceAppExcludeapi: '/adminApi/adminapi/appExclude/insertDeviceAppExclude',
  /* 编辑APP黑名单 */
  updateDeviceAppExcludeapi: '/adminApi/adminapi/appExclude/updateDeviceAppExclude',
  // 获取设备状态 -在线、离线
  queryDeviceState: '/adminApi/adminapi/deviceInstructions/getDeviceState',
  // 查询已有ota
  queryExistingOta: '/adminApi/adminapi/otaManger/selectExistingOTA',

  // ota黑名单
  queryOtaBlackListPage: '/backstageApi/account/backstage/otaBlackList/selectPage',
  insertOtaBlackList: '/backstageApi/account/backstage/otaBlackList/insert',
  updateOtaBlackList: '/backstageApi/account/backstage/otaBlackList/update',
  updateStatusOtaBlackList: '/backstageApi/account/backstage/otaBlackList/updateStatus',
  selectOtaUpgradeLogPageApi: '/backstageApi/upgradeLog/selectOtaUpgradeLogPage',
  queryApkPUpgradeLogPageApi: '/backstageApi/upgradeLog/queryApPUpgradeLogPage',

  // apk update list
  queryApkUpdateListPage: '/adminApi/ApkUpdateManager/queryAppUpdatesPage',
  insertApkUpdateList: '/adminApi/ApkUpdateManager/saveAppUpdate',
  updateApkUpdateList: '/adminApi/ApkUpdateManager/editAppUpdate',
  selectApkUpdateOneById: '/adminApi/ApkUpdateManager/selectApkUpdateOneById',

}



// WEBPACK FOOTER //
// ./src/api/device/otaapi.js